export const getRateCellValue = (value) => {
    if (Boolean(value) && typeof value === 'string' && !isNaN(Number(value))) {
        value = Number(value);
    }
    return value;
};
export function rateCellKeyCreator(params) {
    var _a;
    return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toFixed(4);
}
